import { render, staticRenderFns } from "./ClientReportTabs.vue?vue&type=template&id=727945de&scoped=true"
import script from "./ClientReportTabs.vue?vue&type=script&lang=js"
export * from "./ClientReportTabs.vue?vue&type=script&lang=js"
import style1 from "./ClientReportTabs.vue?vue&type=style&index=1&id=727945de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727945de",
  null
  
)

export default component.exports